import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core'
import * as _ from 'lodash'
import { NgTemplateOutlet, NgClass, NgStyle } from '@angular/common';

export interface ILinkConfig {
   href: string,
   target: string,
   title: string,
   tabIndex: string
   text: string
   textChange: string[]
   class: string
   imageUrl: string
   svg: any
}

@Component({
    selector: 'app-link',
    templateUrl: './link.component.html',
    imports: [NgTemplateOutlet, NgClass, NgStyle]
})
export class LinkComponent implements AfterViewInit, OnChanges {
   @Input() linkConfig = {} as ILinkConfig
   @Input() disabled: boolean
   @Input() textChangeIndex: number
   @Output() textBtnClickEmt: EventEmitter<string> = new EventEmitter<string>();
   @ViewChild('link') link: ElementRef<HTMLAnchorElement>;

   constructor() { }

   ngAfterViewInit() {
      /* setting target after the fact
         due to app Android issues we want to NOT
         set it at all if not specified*/
      if (this.linkConfig.target) {
         this.link.nativeElement.setAttribute('target', this.linkConfig.target)
      }
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes?.['linkConfig']?.currentValue) {

         //this.linkConfig.svgType = this.linkConfig.svgType || 'add';
         if (this.linkConfig.text || this.linkConfig.textChange) {
            this.linkConfig.class = `text-nowrap ${(this.linkConfig.class || 'btn btn-site-secondary')}`

            if (_.isArray(this.linkConfig.textChange)
               && this.linkConfig.textChange.length) {
               this.textChangeIndex = this.textChangeIndex || 0
               this.linkConfig.text = this.linkConfig.textChange[this.textChangeIndex]
            }

            if (!this.linkConfig.text) {
               this.linkConfig.text = 'Submit'
            }
         }
      } else if (this.linkConfig.textChange
         && changes?.['textChangeIndex']
         && [0, 1].includes(changes['textChangeIndex'].currentValue)) {
         this.linkConfig.text = this.linkConfig.textChange[this.textChangeIndex]
      }
   }

   /*
    * public methods
    * */

   onLinkClick(): void {
      this.textBtnClickEmt.emit('You have clicked on a link.')
   }

}

/* USE:
https://medium.com/better-programming/how-to-create-a-reusable-button-component-in-angular-42893f521834

<app-button [linkConfig]="textBtnConfig"
            (textBtnClickEmt)="onClickEventReceived($event)"></app-button>
<app-button [linkConfig]="imgBtnConfig"
            (imgBtnClickEmt)="onClickEventReceived($event)"></app-button>

textBtnConfig = {
    styles: {
      position: 'relative',
      width: '150px',
      height: '60px',
      backgroundColor: '#f92672',
      color: '#fff',
      fontFamily: 'sans-serif',
      fontSize: '20px',
      borderRadius: '10px',
      marginTop: '30px'
    },
    text: 'Click Here'
  };

  imgBtnConfig = {
    styles: {
      position: 'relative',
      width: '100px',
      height: '100px'
    },
    src: './assets/conversation.png'
  };

*/
